import { selectWixAppsCollections } from '../../collections';
import type { MapStateToProps } from 'types/redux';
import type { Schema } from '@wix/wix-data-schema-types';
import type { CollectionsListOwnProps } from '../collectionsList/collectionsList.mapper';

export interface WixAppsCollectionsListOwnProps
  extends CollectionsListOwnProps {}

export interface WixAppsCollectionsListStateProps {
  collections: Schema[];
}

export const mapStateToProps: MapStateToProps<
  WixAppsCollectionsListStateProps
> = ({ state }) => ({
  collections: selectWixAppsCollections(state),
});
